import { signIn, signUp } from 'aws-amplify/auth';
import mixpanel from 'mixpanel-browser';
import {
  createSimpleSpaceMembershipOperation,
  createPreactivatedSpaceMembershipOperation,
} from '../operations/user_profile_operations';
import {
  createContactOperation,
  emailHealthProWelcomeMessageOperation,
  updateContactAttributeOperation,
} from '../operations/email_list_operations';
import {
  isEmbeddedInSmorgCompanion,
  spaceMembershipDefaultReferrer,
} from '../services/smorg_companion_auth';
import { DEFAULT_SPACE_ID } from '../services/spaces';
import {
  currentUserSelector,
  dispatchAmplifyUser,
  loginStarted,
} from '../features/user_id/user_id_slice';
import { answersReset } from '../features/end_user_onboarding/end_user_onboarding_slice';
import { PROGRAMMES_STUDIO_FEATURE_CODE } from '../services/programmes';
import { appSyncGraphQLApi } from '../app/smorgAppSyncGraphQLApi';
import {
  cancelGlobalLoading,
  setGlobalLoading,
} from '../features/loader/loader_slice';
import { trackEvents } from '../operations/tracking_operations';

export const signupAction = (
  email,
  givenName,
  familyName,
  consentToProductComms,
  cleartextPassword,
  isCreator,
  sharedBoardIDToImport,
  intoSpaceID,
  createUserProfile,
) => {
  return async (dispatch) => {
    // dispatch(setGlobalLoading());
    try {
      const { isSignUpComplete, userId } = await signUp({
        username: email,
        password: cleartextPassword,
        options: {
          userAttributes: {
            email,
            given_name: givenName,
            family_name: familyName,
          },
        },
      });
      console.log({ isSignUpComplete, userId });
      mixpanel.alias(userId);
      trackEvents([{ name: 'Sign up', args: { email } }]);
      await createContactOperation(email, givenName, familyName);
      // Launch the operation in background
      updateContactAttributeOperation(
        email,
        'consentToProductComms',
        consentToProductComms.toString(),
      );
      if (isCreator) {
        await emailHealthProWelcomeMessageOperation(
          email,
          givenName,
          familyName,
        );
      }
      await dispatch(
        loginAfterSignupAction(
          email,
          cleartextPassword,
          isCreator,
          consentToProductComms,
          sharedBoardIDToImport,
          intoSpaceID,
          createUserProfile,
        ),
      );
    } finally {
      // dispatch(cancelGlobalLoading());
    }
  };
};

export const loginAction = (email, cleartextPassword) => {
  return async (dispatch) => {
    try {
      dispatch(loginStarted());
      await signIn({ username: email, password: cleartextPassword });
    } finally {
      await dispatchAmplifyUser(dispatch);
    }
  };
};

export const loginAfterSignupAction = (
  email,
  cleartextPassword,
  isCreator,
  consentToProductComms,
  sharedBoardIDToImport,
  intoSpaceID,
  createUserProfile,
) => {
  return async (dispatch, getState) => {
    try {
      dispatch(loginStarted());
      await signIn({ username: email, password: cleartextPassword });
    } finally {
      await dispatchAmplifyUser(dispatch);
    }
    if (intoSpaceID) {
      const { endUserSpaceOnboardingAnswers } = getState().endUserOnboarding;
      const referrer = spaceMembershipDefaultReferrer();
      console.log(
        `Creating membership into space ${intoSpaceID}, referrer: ${referrer}`,
      );
      let createdSpaceMembership = null;
      if (isEmbeddedInSmorgCompanion()) {
        createdSpaceMembership = await createSimpleSpaceMembershipOperation(
          intoSpaceID,
          endUserSpaceOnboardingAnswers,
          referrer,
        );
      } else if (!intoSpaceID || intoSpaceID === DEFAULT_SPACE_ID) {
        createdSpaceMembership =
          await createPreactivatedSpaceMembershipOperation(
            intoSpaceID,
            referrer,
          );
      } else {
        createdSpaceMembership = await createSimpleSpaceMembershipOperation(
          intoSpaceID,
          endUserSpaceOnboardingAnswers,
          referrer,
        );
      }
      if (createdSpaceMembership) {
        dispatch(appSyncGraphQLApi.util.invalidateTags(['SpaceMembership']));
        dispatch(
          appSyncGraphQLApi.util.updateQueryData(
            'getSpaceMembershipsByMemberID',
            createdSpaceMembership.memberID,
            (draft) => {
              draft.push(createdSpaceMembership);
            },
          ),
        );
      }
      dispatch(answersReset());
    }
    const { username: currentUserID } = currentUserSelector(getState());
    const userProfileDoc = {
      userID: currentUserID,
      consentToProductComms,
      showOnboarding: isCreator,
    };
    if (isCreator) {
      userProfileDoc.requestedFeatures = [PROGRAMMES_STUDIO_FEATURE_CODE];
      userProfileDoc.enabledFeatures = [PROGRAMMES_STUDIO_FEATURE_CODE];
    }
    await createUserProfile(userProfileDoc);
    // if (sharedBoardIDToImport) {
    //   const { sharedBoard, sharedMeals } = await loadSharedBoard(
    //     sharedBoardIDToImport,
    //   );
    //   const firstRecipesBoard = getState().mealboard.recipesBoards[0];
    //   console.log({ firstRecipesBoard, sharedBoard, sharedMeals });
    //   // TODO implement
    // }
  };
};

// const migrateOnboardingAnswers = async () => {
// };
